import { FaMoneyBillTrendUp } from "react-icons/fa6";

const FinanceAnalyticsIcon = () => {
  return <FaMoneyBillTrendUp size={23} className="sidebar-icon" />;
};

export default FinanceAnalyticsIcon;
